export const TAB_NAME_MAP = {
    FoxitESign: 'foxit-eSign',
    FillSign: 'fill-sign',
    ESignChina: 'eSign-china'
}

export const CLASS_NAME_MAP = {
    [TAB_NAME_MAP.FillSign]: 'fill-sign',
    [TAB_NAME_MAP.FoxitESign]: 'foxit-eSign',
    [TAB_NAME_MAP.ESignChina]: 'eSign-china'
}

export const IndexDBSuffixMap = {
    [TAB_NAME_MAP.FillSign]: 'FillSign',
    [TAB_NAME_MAP.FoxitESign]: 'FoxitESign'
}

export const FieldType = {
    Signature: 'signature',
    Initial: 'initial'
}

export const FoxitSignSubtypeMap = {
    [FieldType.Signature]: 'FoxitSignFS',
    [FieldType.Initial]: 'FoxitSignIS'
} 

// windows 11 默认字体
// export const FontMap = {
//     BernardMT: 'Bernard MT',
//     Broadway: 'Broadway',
//     Britannic: 'Britannic',
//     Cooper : 'Cooper',
//     Forte : 'Forte',
//     Magneto : 'Magneto',
//     Ravie : 'Ravie'
// }
// export const FontList = [ FontMap.BernardMT, FontMap.Broadway, FontMap.Britannic, FontMap.Cooper, FontMap.Forte, FontMap.Magneto, FontMap.Ravie ];

export const FontMap = {
    Zeyada: 'Zeyada',
    GrandHotel: 'Grand Hotel',
    TimesNewRoman: 'Times New Roman',
    OverTheRainbow : 'Over The Rainbow',
    NothingYouCouldDo : 'Nothing You Could Do',
    Rancho : 'Rancho'
}
export const FontList = [
    FontMap.Zeyada,
    FontMap.GrandHotel,
    FontMap.TimesNewRoman,
    FontMap.OverTheRainbow,
    FontMap.NothingYouCouldDo,
    FontMap.Rancho
]

// eSign-china 字体 兼容windows Mac Linux
export const BaseFontFamiliesCN = [
    'SimHei,STHeiti,Noto Serif Hebrew',
    'CESI_KT_GB2312,KaiTi,STKaiti',
    'FangSong,STFangSong,CESI_FS_GB13000',
    'SimSun,STSong,CESI_SS_GB13000'
];

export const StyleTypes = {
    Type: 'type',
    Draw: 'draw',
    Import: 'import',
    Paste: 'paste',
    Online: 'online'
}

export const eSignChinaStyleTypes = {
    Type: 'type',
    Draw: 'draw',
    Import: 'import',
    Paste: 'paste'
}

export const StyleTypeList = [ 
    StyleTypes.Type,
    StyleTypes.Draw,
    StyleTypes.Import,
    StyleTypes.Paste,
    StyleTypes.Online
];

export const DefaultSignatureOptions = {
    convertSignatureToBlackWhite : true,
    keepOriginalSize: false,
    discardCloses: false,
    requirePassword: false,
    password: ''
}

export const DefaultSignatureStyle = (fieldType) => ({
    fieldType: fieldType,
    styleType: StyleTypes.Type,
    font: FontMap.Zeyada,
    fontSize: 12,
    [`${fieldType === FieldType.Signature ? 'fullName' : 'initials'}`]: '',
    originImageBase64: '',
    imageBase64: '',
    imageSourceWithDetails: '',
    styleId: '',
    groupId: '',
    isOnCloud: false,
    lastModify: new Date().getTime(),
    createTime: new Date().getTime(),
    options: { ...DefaultSignatureOptions },
    order: undefined
})